<template>
  <el-tree
      :data="menuList"
      show-checkbox
      node-key="id"
      ref="tree"
      accordion
      highlight-current
      :check-strictly="true"
      :props="defaultProps">
  </el-tree>
</template>

<script>
export default {
  name: "RoleTab",
  props: ['sourceType'],
  computed:{
    menuList(){
      return this.$store.state.user.menuList;
    }
  },
  data() {
    return {
      defaultProps:{children: 'children', label: 'name'},
    }
  },
  methods: {
    getKeys(){
      return this.$refs.tree.getCheckedKeys();
    },
    setKeys(keys){
      return this.$refs.tree.setCheckedKeys(keys);
    },
    resetTree(){
      this.setKeys([]);
    },
  },
  mounted() {
  }
}
</script>


<style lang="less" scoped>

</style>
